import {changeEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";
import {hideOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";
import {
    hideOptionErrors,
    updatePriceElements,
    updateSizesPrices
} from "../../../../../webpack/modules-optimized/product-page";
import {getSizesPricesByPack} from "../../../../../webpack/modules-optimized/product";

changeEvent('#product-page .options[data-option-type="selectable"] input[name="pack"]', false, async function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);

    offcanvas.querySelectorAll('.pack.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    dispatchCustomEvent(
        'productPackChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement
        }
    );
    hideOffcanvas(offcanvas.id);
    updateSizesPrices(container);
    updatePriceElements(container);
    hideOptionErrors(offcanvas);
});

function updateSizesPriceByPack(container)
{
    return new Promise(async function (resolve) {
        let productId = container.dataset.productId;
        let productIndex = container.dataset.productIndex || 1;
        let pack = container.querySelector('input[name="pack"]:checked');

        if (!pack) return;

        let prices = await getSizesPricesByPack(productId, pack.value);

        prices.forEach(function (element) {
            let id = element.id;
            let price = element.price;
            let oldPrice = element.oldPrice;
            let input = container.querySelector(`.options[data-type="size"][data-product-index="${productIndex}"] input[name="size"][value="${id}"]`);
            let label = container.querySelector(`label[for="${input.id}"]`);

            input.dataset.price = price;
            label.querySelector('.size-price').innerHTML = price;
            if (oldPrice) {
                input.dataset.oldPrice = oldPrice;
                label.querySelector('.size-old-price').innerHTML = oldPrice;
            }
        });

        resolve();
    });
}